export default __webpack_public_path__ + "static/media/modal-proprietarios-novo-sol.c7a554d6.webp";